import { html } from 'lit';
import { fixture, expect } from '@open-wc/testing';
import { IxGenericTree } from '../IxGenericTree.js';
import ixGenericTreeTestData from './test-data.js';
import '../ix-generic-tree.js';

describe('A11yTest', () => {
  // TODO
  it('passes the a11y audit', async () => {
    const el = await fixture<IxGenericTree>(
      html`<ix-generic-tree
        .rootNode=${ixGenericTreeTestData}
        searchEnabled
        searchPlaceholder="placeholder"
      ></ix-generic-tree>`,
    );

    // await expect(el).shadowDom.to.be.accessible();
    await expect(el).shadowDom.to.not.be.accessible();
  });
});
